import { ACTION } from '@talos/kyoko';
import type { ConditionalLayoutSpecRule } from '../conditionalLayoutSpecs';
import { DEALER_CUSTOMER_RISK_LAYOUT_TEMPLATE_ID, DEALER_EXECUTION_AND_PRICING_LAYOUT_TEMPLATE_ID } from '../tokens';
import { CUSTOMER_RISK_LAYOUT_SPEC } from './CustomerRiskLayoutSpec';
import { EXECUTION_AND_PRICING_LAYOUT_SPEC } from './ExecutionAndPricingLayoutSpec';

export const DEALER_CONDITIONAL_LAYOUT_SPEC_RULES = {
  [DEALER_CUSTOMER_RISK_LAYOUT_TEMPLATE_ID]: {
    layoutSpec: CUSTOMER_RISK_LAYOUT_SPEC,
    isVisible: ({ flags, isAuthorized }) =>
      isAuthorized(ACTION.VIEW_DEALER) && flags.viewDealerAdminAndBuyingPowerMenuItems,
  },
  [DEALER_EXECUTION_AND_PRICING_LAYOUT_TEMPLATE_ID]: {
    layoutSpec: EXECUTION_AND_PRICING_LAYOUT_SPEC,
    isVisible: ({ flags, isAuthorized }) =>
      isAuthorized(ACTION.VIEW_DEALER) &&
      flags.showCustomerTiering &&
      flags.showCustomerPricingRulesBeta &&
      isAuthorized(ACTION.VIEW_CUSTOMER_SYMBOL_GROUPS) &&
      isAuthorized(ACTION.VIEW_CUSTOMER_PRICING_TIERS),
  },
} satisfies Record<string, ConditionalLayoutSpecRule>;
